import React, { Component, ErrorInfo, ReactNode } from "react";
import { AlertCircle, RefreshCw } from "lucide-react";
import { Button } from "./button";

interface Props {
  children?: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  public override state: State = {
    hasError: false,
    error: null
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public override componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Uncaught error:", error, errorInfo);
  }

  public override render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-[400px] flex items-center justify-center p-8 text-center">
          <div className="max-w-md space-y-4">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-red-100 text-red-600 mb-2">
              <AlertCircle className="w-8 h-8" />
            </div>
            <h2 className="text-2xl font-bold text-[#0C1A12]">Algo deu errado</h2>
            <p className="text-gray-600">
              Ocorreu um erro ao carregar esta seção. Por favor, tente recarregar a página.
            </p>
            <div className="bg-red-50 p-4 rounded-lg text-left overflow-auto max-h-40">
              <pre className="text-xs text-red-800 whitespace-pre-wrap">
                {this.state.error?.message}
                {"\n"}
                {this.state.error?.stack}
              </pre>
            </div>
            <Button 
              onClick={() => window.location.reload()}
              className="bg-[#0C1A12] text-white hover:bg-[#0C1A12]/90"
            >
              <RefreshCw className="w-4 h-4 mr-2" />
              Recarregar Página
            </Button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
